export default __webpack_public_path__ + "static/media/incomming-transaction.01c67ca1.svg";